import { render, staticRenderFns } from "./MplsOverInternetWizard.vue?vue&type=template&id=50ab6b5a&"
import script from "./MplsOverInternetWizard.vue?vue&type=script&lang=js&"
export * from "./MplsOverInternetWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports